// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"92202a92","160":"daed8b06","208":"369bc52c","293":"3e7f9730","516":"0c94a795","519":"d1d58da3","840":"67d3830d","917":"41562d34","946":"2b495859"}[chunkId] + ".chunk.js";
};